"use strict";
/**
 *  regionalHotspotsNavModule Module
 *
 * Description 策划中心 指挥监测中心 地域热点分析nav切换
 * Author: fanglijuan 2017-7-14
 */
angular.module('regionalHotspotsNavModule', [])
    .controller('regionalHotspotsNavController', ["$scope", "$location", "trsHttpService", function($scope, $location, trsHttpService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.currRegionalHotspotsModule = $location.path().split("/").pop();
            $scope.regionalHotspotsNavTab = {
                'regionalhotfeaturelist': false,
                'customhotspotcontentmgr': false,
                'zjhotspotcontentmgr': false,
                'countryhotspotcontentmgr': false,
                'internationalhotspotcontentmgr': false,
            };
            $scope.regionalHotspotsNavTab[$scope.currRegionalHotspotsModule] = true;
        }

        function initData() {            
             judgeCity();
        }
        function judgeCity(){
            var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'searchAreaHot',
                    "sceneid": 10
                };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'post').then(function(data){
                if(data.city === null || data.city === ''){
                    $scope.isAdd = false;
                }else{
                    $scope.isAdd = true;
                }
            });
        }
    }]);
